import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<ellipse cx="16" cy="12" rx="1.5" ry="1"/><path d="M29.6 11.56L17 7.14A3.26 3.26 0 0016 7a3.22 3.22 0 00-1 .14L2.42 11.56c-.54.19-.54.5 0 .69L15 16.67a2.94 2.94 0 001 .14 3 3 0 001-.14l5-1.76v5.54a.43.43 0 010 .11c-.23.36-1.72 2.44-6 2.44s-5.75-2.08-6-2.44v-3.48l-2-.7v4.12a2.63 2.63 0 00.22.95S10 25 16 25s7.78-3.55 7.78-3.55a2.63 2.63 0 00.22-.95v-6.29l2-.7v7.55a.94.94 0 00.94.94h.12a.94.94 0 00.94-.94v-8.25l1.6-.56c.53-.19.53-.5 0-.69zm-13.26 3.22a1.38 1.38 0 01-.33 0 1.2 1.2 0 01-.32 0l-8.2-2.87L15.68 9A1.38 1.38 0 0116 9a1.2 1.2 0 01.32 0l8.2 2.88z"/>';
export var GraduationCapOutlineSVG = function GraduationCapOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
GraduationCapOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(GraduationCapOutlineSVG);